var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 472.148 472.148",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M407.698,209.068V75.843c0-22.988-20.375-39.184-43.363-39.184h-35.004V8.448c0.626-3.991-2.102-7.733-6.093-8.359     c-0.751-0.118-1.516-0.118-2.266,0h-49.633c-5.747,0-9.927,2.612-9.927,8.359V36.66H146.474V8.448     c0-5.747-6.792-8.359-12.539-8.359H84.302c-5.747,0-10.971,2.612-10.971,8.359V36.66H41.462     c-22.988,0-41.273,16.196-41.273,39.184v303.02c0,22.988,18.286,39.184,41.273,39.184H215.96     c49.473,62.037,139.87,72.223,201.907,22.75c33.975-27.094,53.862-68.111,54.093-111.566     C471.113,281.172,447.199,236.455,407.698,209.068z M282.311,20.986h26.122v47.02h-26.122V20.986z M94.229,20.986h31.347v47.02     H94.229V20.986z M21.086,75.843c0-11.494,8.882-18.286,20.376-18.286h31.869v19.853c0.241,6.048,4.942,10.972,10.971,11.494     h49.633c6.358-0.416,11.572-5.196,12.539-11.494V57.558h114.939v19.853c-0.306,5.872,4.072,10.942,9.927,11.494h49.633     c5.747,0,8.359-5.747,8.359-11.494V57.558h35.004c11.494,0,22.465,6.792,22.465,18.286v65.306H21.086V75.843z M41.462,397.15     c-11.494,0-20.376-6.792-20.376-18.286V162.047H386.8v36.049c-18.356-7.834-38.039-12.089-57.992-12.539     c-79.349,0.096-143.596,64.498-143.5,143.847c0.029,23.642,5.891,46.911,17.067,67.745H41.462z M327.764,451.484     c-67.806,0.288-123.008-54.447-123.296-122.253c-0.288-67.806,54.447-123.008,122.253-123.296     c67.806-0.288,123.008,54.447,123.296,122.253c0.001,0.348,0.001,0.695,0,1.043C450.017,396.75,395.282,451.484,327.764,451.484z     ",
    fill: "#333333",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.874,329.231h-47.543v-62.694c0-5.771-4.678-10.449-10.449-10.449c-5.771,0-10.449,4.678-10.449,10.449v73.143     c1.03,6.099,6.354,10.535,12.539,10.449h55.902c5.771,0,10.449-4.678,10.449-10.449S382.645,329.231,376.874,329.231z",
    fill: "#333333",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3);
export default __webpack_public_path__ + "static/media/calendar3.7e8ba9a001fe4ffc330419085217dd58.svg";
export { ForwardRef as ReactComponent };